import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'acabim-admin-third-party',
  templateUrl: './third-party.component.html',
  styleUrls: ['./third-party.component.scss']
})
export class ThirdPartyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
